module.exports = __webpack_public_path__ + "img/MF.a3e7010f.svg";